exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#freight-table::-webkit-scrollbar,#freight-table::-webkit-scrollbar-thumb{appearance:none}@media (max-width:1000px){::-webkit-scrollbar:horizontal{height:14px!important}-webkit-scrollbar-track{display:block!important}}#freight-table::-webkit-scrollbar{width:6px!important;cursor:pointer!important;background:#edf2f7!important;border-radius:9999px!important}#freight-table::-webkit-scrollbar-thumb{background:#a0aec0!important;border-radius:9999px!important}a.text-info{color:#4682b4}a.text-info:hover{color:blue}", ""]);

// exports
